module.exports = __webpack_public_path__ + "img/ir.6d32f579.svg";